








































import { Vue, Component, Prop } from 'vue-property-decorator'


import { changeAvatarUrl } from '@/api/users'
@Component
export default class Edit extends Vue {
  @Prop()  form!: {}
  changeAvatarUrl = changeAvatarUrl;
  activeName = 'baseInfo';
}
